import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';

import { LandingpageComponent } from './components/landingpage/landingpage.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginComponent } from './components/auth/Pages/login/login.component';
import { landingPageComponent } from './components/landing-page/landingPage/landingPage.component';
import { NgModule } from '@angular/core';
import { LicenceComponent } from './components/licence/licence.component';

import { BasicInformationComponent } from './components/charity/basic-information/basic-information.component';
import { AdvisorComponent } from './components/charity/advisor/advisor.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ProfileComponent } from './pages/apps/profile-content/profile/profile.component';
import { FinancialstatementsComponent } from './components/charity/financialstatements/financialstatements.component';
import { NotesofaccountsComponent } from './components/charity/notesofaccounts/notesofaccounts.component';
import { ReceiptsandPaymentsComponent } from './components/charity/receiptsand-payments/receiptsand-payments.component';
import { StatementofassetsComponent } from './components/charity/statementofassets/statementofassets.component';
import { BalancesheetComponent } from './components/charity/balancesheet/balancesheet.component';
import { ReportsComponent } from './components/charity/reports/reports.component';
import { Note4Component } from './components/charity/notesofaccounts/note4/note4.component';
import { Candeactivate } from './candeactivate/candeactivate';
import { AccountNotesComponent } from './components/charity/notes/account-notes/account-notes.component';
import { TrusteeannualreportComponent } from './components/charity/trusteeannualreport/trusteeannualreport.component';
import { StatementoftrusteesComponent } from './components/charity/statementoftrustees/statementoftrustees.component';
import { IndependentExaminerReportComponent } from './components/charity/independent-examiner-report/independent-examiner-report.component';
import { AuditorReportComponent } from './components/charity/auditor-report/auditor-report.component';
import { FinalAccountsComponent } from './components/charity/final-accounts/final-accounts.component';
import { SubmissionsComponent } from './components/charity/submissions/submissions.component';
import { TrialBalanceExampleComponent } from './components/charity/trailbalance/trial-balance-example/trial-balance-example.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive/lib/module';
import { SubmissionHistoryComponent } from './components/submission-history/submission-history.component';
import { CredentialsComponent } from './components/credentials/credentials.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { HelpMainSecComponent } from './components/helpfile/help-main-sec/help-main-sec.component';
import { HelpfileComponent } from './components/helpfile/helpfile.component';
import { HelpCharitiesComponent } from './components/helpfile/help-charities/help-charities.component';
import { helpfileroutes } from './components/helpfile/helpfile.route';

export const routes: Routes = [ 

  {

    path: '',
    title: 'Andica Charity Accounts Software',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', title: 'Andica Charity Accounts', component: LoginComponent, canActivate: [AuthGuard], },
      { path: 'landingpage', title: 'Andica Charity Accounts', component: landingPageComponent, canActivate: [AuthGuard], },
      { path: 'charity', loadChildren: () => import('./components/charity/charity.routing').then((m) => m.charityroutes), canActivate: [AuthGuard] },
      { path: 'licence', title: 'Andica Charity Accounts', component: LicenceComponent },
      { path: 'basicinformation', title: 'Andica Charity Accounts', component: BasicInformationComponent },
      { path: 'thirdparty', title: 'Andica Charity Accounts', component: AdvisorComponent },
      
      { path: 'profile', title: 'Andica Charity Accounts', component: ProfileComponent },
      { path: 'financialactivities', title: 'Andica Charity Accounts', component: FinancialstatementsComponent },
      { path: 'notes-accounts', title: 'Andica Charity Accounts', component: NotesofaccountsComponent },
      { path: 'receiptsandpayments', title: 'Andica Charity Accounts', component: ReceiptsandPaymentsComponent },
      { path: 'assets-statements', title: 'Andica Charity Accounts', component: StatementofassetsComponent },
      { path: 'balancesheet', title: 'Andica Charity Accounts', component: BalancesheetComponent },
      { path: 'reports', title: 'Andica Charity Accounts', component: ReportsComponent },
      { path: 'reports', loadChildren: () => import('./components/charity/reports/reports.routing').then((m) => m.reportsroutes) },
      { path: 'settings', loadChildren: () => import('./components/settings/setting.routing').then((m) => m.settingrouting) },
      { path: 'Accountnotes', title: 'Andica Charity Accounts', component: AccountNotesComponent },
    //  { path: 'landingpage', title: 'Andica Charity Accounts', component: landingPageComponent, canActivate: [AuthGuard],},
      { path: 'trusteeannualreport', title: 'Andica Charity Accounts', component: TrusteeannualreportComponent, canDeactivate: [Candeactivate] },
        { path: 'statementoftrustees', title: 'Andica Charity Accounts', component: StatementoftrusteesComponent, canDeactivate: [Candeactivate] },
      { path: 'independentexaminerreport', title: 'Andica Charity Accounts', component: IndependentExaminerReportComponent, canDeactivate: [Candeactivate]},
      { path: 'audit-report', title: 'Andica Charity Accounts', component: AuditorReportComponent, canDeactivate: [Candeactivate] },
      { path: 'final-accounts', title: 'Andica Charity Accounts', component: FinalAccountsComponent, canDeactivate: [Candeactivate] },
      { path: 'submissions', title: 'Andica Charity Accounts', component: SubmissionsComponent },
        { path: 'TrialBalanceExampleComponent', title: 'Andica Charity Accounts', component: TrialBalanceExampleComponent },
      { path: 'trialbalance', title: 'Andica Charity Accounts', component: TrialBalanceExampleComponent, canDeactivate: [Candeactivate] },
      { path: 'submissionHistory', title: 'Andica Charity Accounts', component: SubmissionHistoryComponent },
    ]
  },
   { path: 'credentials', title: 'Andica Charity Accounts', component: CredentialsComponent },
  { path: 'forgot-password', title: 'Andica Charity Accounts', component: ForgotPasswordComponent },
  { path: 'helpfile', title: 'Andica Charity Accounts', children: helpfileroutes },
]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
      exports: [RouterModule]

})
export class AppRoutingModule { }
